<div class="pb-10">
  <div *ngFor="let section of menu; let i = index" class="tab">
    <input class="absolute opacity-0" [id]="i" type="checkbox" name="tabs" />
    <div class="pt-5 font-normal text-[1.5rem] mb-4" [for]="i">
      <pulse-icon icon='arrow_right' size='16' color='primary'></pulse-icon>
      {{ section.title }}
    </div>
    <nav class="tab-content overflow-hidden leading-normal">
      <ul class="pl-5">
        <li
          class="py-2 cursor-pointer border-l pl-2 text-sm font-light"
          [ngClass]="[
            isActive(option.route)
              ? 'bg-primary-500 text-primary-500'
              : 'hover:border-primary-500'
          ]"
          *ngFor="let option of section.options"
        >
          <a [href]="option.id">
            {{ option.title }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>
